// extracted by mini-css-extract-plugin
export default {"divider":"WordRace_divider__TBgp0","wordsContainer":"WordRace_wordsContainer__HFEKT","word":"WordRace_word__xdgG5"};